<template>
    <div class="reset-anime">
        <h2>Сбросить пароль</h2>
        <div class="reset-block">
            <div class="reset-form">
                <form v-if="isEmailSend" onsubmit="return false">
                    <label for="">Новый пароль</label>
                    <input v-model="newPassword" type="password">
                    <label for="">Потвеждение пароля</label>
                    <input v-model="confirmPassword" type="password">
                    <button @click="resetPassword()" class="reset-button">Отправить</button>
                </form>
            </div>
        </div>
    </div>
    
  </template>
  
  <script>
  import axios from "axios";

 
  
  export default {
    data() {
      return {
        url: 'https://anione.fun/api/reset.php',
        newPassword: '',
        confirmPassword: '',
        isEmailSend: true
      };
    },
    methods: {
        resetPassword: function(){
            if(this.isValid(this.newPassword) && this.isValid(this.confirmPassword)){
                if(this.newPassword !== this.confirmPassword){
                    alert('Пароли не совпадают!');
                    return;
                }
                let [reset_token, email] = window.location.pathname.replace('/reset/','').split(':');
                let resetUrl = this.url + `?new_password=${this.confirmPassword}&reset_token=${reset_token}&email=${email}`;
                console.log(resetUrl);
                axios
                .get(resetUrl)
                .then((response) => {
                    console.log(response.data);
                    if(response.data){
                        console.log('Probably password was reset');
                        window.location.pathname = '/auth';
                    }
                    alert(response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
            }




           
            
        },
        isValid: function(value){
            const cyrillicPattern = /[А-Яа-я]/;
            let isValidValue = false;
            if(value.length >= 3){
                isValidValue = true;
            }
            if(value.length < 3){
                alert('Логин или пароль слишком короткие');
                return false;
            }
            if(!cyrillicPattern.test(value)){
                isValidValue = true;
            }
            if(cyrillicPattern.test(value)){
                console.log('nor cyrilic');
                alert('Логин(Nickname) не может содержать кириллицу');
                return false;
            }
            return isValidValue;
        }
    }
    
  };
  </script>
  
<style>

.reset-form {
    display: flex;
    width: 300px;
    flex-direction: column;
}

.reset-form form{
    widows: 100%;
}


.reset-block {
    display: flex;
    justify-content: center;
}

.reset-form {
    display: flex;
    width: 300px;
    flex-direction: column;
}

.reset-anime .reset-form label {
    padding: 10px 0 5px 0;
    font-family: 'Montserrat', sans-serif;
}

.reset-anime .reset-form input {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    border: none;
    font-family: 'Exo 2', sans-serif;
    font-size: 18px;
    margin-top: 6px;
    margin-bottom: 10px;
}

.reset-anime .reset-form .reset-button {
    color: white;
    background-color: #0d6efd;
}

.reset-anime .reset-form button {
    padding: 5px 10px;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-family: 'Montserrat';
    margin-top: 10px;
    cursor: pointer;
}
  </style>